
export const _optic = Symbol("optic")

